// extracted by css-extract-rspack-plugin
export default {"tagSuccess":"tagSuccess-Asaymv","tagWarn":"tagWarn-_yxHU3","tagSuccess2":"tagSuccess2-ElQbgh","base":"base-P4_oyf"};